import { render, staticRenderFns } from "./edit-course.vue?vue&type=template&id=6f351d23&scoped=true"
import script from "./edit-course.vue?vue&type=script&lang=js"
export * from "./edit-course.vue?vue&type=script&lang=js"
import style0 from "./edit-course.vue?vue&type=style&index=0&id=6f351d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f351d23",
  null
  
)

export default component.exports